if (!customElements.get('two-columns')) {
  customElements.define('two-columns', class TwoColumns extends HTMLElement {
    connectedCallback() {
      this.template = this.querySelector('template[data-source]');
      this.leftCol = this.querySelector('[data-column="left"]');
      this.rightCol = this.querySelector('[data-column="right"]');

      if (!this.template || !this.leftCol || !this.rightCol) return;

      this.init();
    }

    init() {
      const items = Array.from(this.template.content.children);
      const mid = Math.ceil(items.length / 2);

      items.forEach((item, i) => {
        const target = (i < mid) ? this.leftCol : this.rightCol;
        target.appendChild(item);
      });

      this.template.remove();
            
      this.dispatchEvent(new CustomEvent('columns-ready', { 
        bubbles: true, 
        detail: { finished: true } 
      }));
    }
  });
}